// extracted by css-extract-rspack-plugin
export default {"cls1":"Playlist-cls1_MMN","cls2":"Playlist-cls2_9xB Playlist-cls1_MMN"};